export const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

export const normalizeProtocolToBlock = (tpl) => ({
  uid: crypto.randomUUID(),
  protocol_template_id: tpl.id,
  code: tpl.code,
  name: tpl.name,
  label: tpl.name,
  start_min: 0,
  duration_min: tpl.default_duration_min ?? 10,
  intensity: tpl.default_intensity ?? 50,
  overrides: {},
});

export const normalizeSessionForMicrocycleItem = (sessionTpl) => ({
  uid: crypto.randomUUID(),
  session_template_id: sessionTpl.id,
  name: sessionTpl.name,
  day_index: 0,
  start_min: 600,
  duration_min: 90,
  label: sessionTpl.name,
  intensity_hint: null,
});

export const serializeSessionBlocks = (blocks) =>
  (blocks || []).map((b, i) => ({
    protocol_template_id: b.protocol_template_id,
    start_min: Math.round(b.start_min),
    duration_min: Math.max(5, Math.round(b.duration_min)),
    intensity: b.intensity ?? null,
    label: b.label ?? null,
    overrides: b.overrides || {},
    sort_order: i,
  }));

export const serializeMicrocycleSessions = (items) =>
  (items || []).map((s, i) => ({
    session_template_id: s.session_template_id,
    day_index: s.day_index,
    start_min: Math.round(s.start_min),
    duration_min: Math.max(10, Math.round(s.duration_min)),
    label: s.label ?? null,
    intensity_hint: s.intensity_hint ?? null,
    sort_order: i,
  }));


export const snap = (v, step) => Math.round(v / step) * step;
